/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import moment from 'moment';
import * as Roles from '../../../constants/role';
import * as selectorsProgramacaoDiarias from '../../../store/programacaoDiaria/reducer';
import * as actionsProgramacaoDiarias from '../../../store/programacaoDiaria/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import {
  DatePickerV2,
  DialogDefaultV2,
  InputV2,
  NsirSelectV2,
  OptionSelectV2,
  UsuarioSelectV2,
  VeiculoSelectV2,
} from '../../../components/v2';
import {
  TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO,
  TIPO_PROGRAMACAO_DIARIA_INSPECAO,
  TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS,
} from '../../../constants/ids';
import { buildRequiredSchema } from 'utils';

const getSchema = data => {
  const schema = buildRequiredSchema(['data', 'inspetorId', 'tipoId']);
  if (TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === data.tipoId) return { ...schema, ...buildRequiredSchema(['cidadeDe', 'cidadePara']) };
  if (TIPO_PROGRAMACAO_DIARIA_INSPECAO === data.tipoId) return { ...schema, ...buildRequiredSchema(['nsirIds', 'descricao']) };
  if (TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === data.tipoId) return { ...schema, ...buildRequiredSchema(['veiculoId']) };

  return schema;
};

const Formulario = ({
  saveProgramacaoDiaria,
  updateProgramacaoDiaria,
  selectedProgramacaoDiaria,
  open,
  id,
  onClose,
  findProgramacaoDiariaById,
}) => {
  const [values, setValues] = useState({ data: moment().valueOf() });
  const [errors, setErrors] = useState({});
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (id) findProgramacaoDiariaById(id);
  }, [id, findProgramacaoDiariaById]);

  useEffect(() => {
    if (id && selectedProgramacaoDiaria && id === selectedProgramacaoDiaria.id) {
      setValues({
        ...selectedProgramacaoDiaria,
        data: selectedProgramacaoDiaria.data ? Number(selectedProgramacaoDiaria.data) : moment().valueOf(),
      });
      setReadOnly(selectedProgramacaoDiaria.readOnly);
    } else {
      setValues({ data: moment().valueOf() });
      setReadOnly(false);
    }
  }, [id, selectedProgramacaoDiaria]);

  const saveCallback = success => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onSave = () => {
    const erros = validate(values, getSchema(values));
    setErrors(erros);

    if (!erros) {
      if (values.id) updateProgramacaoDiaria(values, saveCallback);
      else saveProgramacaoDiaria(values, saveCallback);
    }
  };

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const handleChange = event => setValues({ ...values, [event.target.name]: event.target.value });

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Programação Diária"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      readOnly={readOnly}
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <DatePickerV2
            label="Data"
            isRequired
            onChange={data => setValues({ ...values, data })}
            value={values.data}
            disabled={readOnly}
            error={!!(errors && errors.data)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <InputV2
            label="Data Inclusão"
            disabled
            value={values.createdAt || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Inspetor"
            isRequired
            onSelect={inspetorId => setValues({ ...values, inspetorId })}
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorId}
            disabled={readOnly}
            error={!!(errors && errors.inspetorId)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Ajudante/Observador"
            onSelect={inspetorAuxiliarId => setValues({ ...values, inspetorAuxiliarId })}
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorAuxiliarId}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <OptionSelectV2
            label="Tipo da Programação"
            codigo="TIPO_PROGRAMACAO_DIARIA"
            isRequired
            onSelect={tipoId => setValues({ ...values, tipoId })}
            value={values.tipoId}
            disabled={readOnly}
            error={!!(errors && errors.tipoId)}
            helperText={errors && errors.tipoId ? errors.tipoId[0] || errors.tipoId : null}
          />
        </Grid>

        {TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === values.tipoId && (
          <>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }} />
            <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
              <InputV2
                error={!!(errors && errors.cidadeDe)}
                helperText={errors && errors.cidadeDe ? errors.cidadeDe[0] || errors.cidadeDe : null}
                label="Cidade De"
                name="cidadeDe"
                onChange={handleChange}
                value={values.cidadeDe || ''}
                disabled={readOnly}
                isRequired={TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === values.tipoId}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
              <InputV2
                error={!!(errors && errors.cidadePara)}
                helperText={errors && errors.cidadePara ? errors.cidadePara[0] || errors.cidadePara : null}
                label="Cidade Para"
                name="cidadePara"
                onChange={handleChange}
                value={values.cidadePara || ''}
                disabled={readOnly}
                isRequired={TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === values.tipoId}
              />
            </Grid>
          </>
        )}

        {TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId && (
          <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
            <NsirSelectV2
              onSelect={nsirIds => setValues({ ...values, nsirIds })}
              value={values.nsirIds}
              disabled={readOnly}
              isRequired={TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId}
              error={!!(errors && errors.nsirIds)}
              helperText={errors && errors.nsirIds ? errors.nsirIds[0] || errors.nsirIds : null}
            />
          </Grid>
        )}

        {TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === values.tipoId && (
          <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
            <VeiculoSelectV2
              onSelect={veiculoId => setValues({ ...values, veiculoId })}
              value={values.veiculoId}
              disabled={readOnly}
              isRequired={TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === values.tipoId}
              error={!!(errors && errors.veiculoId)}
              helperText={errors && errors.veiculoId ? errors.veiculoId[0] || errors.veiculoId : null}
            />
          </Grid>
        )}

        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.descricao)}
            helperText={errors && errors.descricao ? errors.descricao[0] || errors.descricao : null}
            isRequired={TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId}
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={3}
            multiline
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  findProgramacaoDiariaById: PropTypes.func.isRequired,
  saveProgramacaoDiaria: PropTypes.func.isRequired,
  updateProgramacaoDiaria: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  selectedProgramacaoDiaria: PropTypes.object,
};

Formulario.defaultProps = {
  selectedProgramacaoDiaria: null,
  id: null,
};

const mapStateToProps = state => ({
  selectedProgramacaoDiaria: selectorsProgramacaoDiarias.getSelectedProgramacaoDiaria(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsProgramacaoDiarias,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
